export default "__VITE_ASSET__34044038__"